import { GOOGLE_CLIENT_ID, GOOGLE_HOSTED_DOMAIN } from '../env';

// The slice of Google Identity Services this app uses.
type GoogleIdentity = {
  initialize: (config: {
    client_id: string;
    callback: (response: { credential: string }) => void;
    hd: string;
  }) => void;
  renderButton: (
    parent: HTMLElement,
    options: { theme: string; size: string; text: string },
  ) => void;
};

declare global {
  interface Window {
    google?: { accounts: { id: GoogleIdentity } };
  }
}

const SCRIPT_URL = 'https://accounts.google.com/gsi/client';
let scriptLoaded: Promise<void> | undefined;

function loadScript(): Promise<void> {
  scriptLoaded ??= new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      scriptLoaded = undefined;
      reject(new Error('Could not load Google sign-in.'));
    };
    document.head.append(script);
  });
  return scriptLoaded;
}

/** Draws Google's "Sign in with Google" button in `parent`; `onCredential` gets the id_token. */
export async function renderGoogleButton(
  parent: HTMLElement,
  onCredential: (idToken: string) => void,
) {
  if (!window.google) {
    await loadScript();
  }
  const identity = window.google?.accounts.id;
  if (!identity) {
    throw new Error('Could not load Google sign-in.');
  }
  identity.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: response => onCredential(response.credential),
    hd: GOOGLE_HOSTED_DOMAIN,
  });
  identity.renderButton(parent, {
    theme: 'outline',
    size: 'large',
    text: 'signin_with',
  });
}
